export default __webpack_public_path__ + "static/media/fauna-indexes-instances-missing.f961e6fc.png";